import { Box, Button, Typography } from "@mui/material";
import React from "react";
import bottomPattern from "./utils/svg/Bottom.svg";
import topPattern from "./utils/svg/Top.svg";
import ErrorPage from "./utils/img/ErrorPage.png"
import { Image } from "@aws-amplify/ui-react";
import { clearCacheAndReloadForVerification } from "./utils/clearCacheAndReload";

type State = { hasError: boolean; error?: Error | null };

// Aquí indicamos que props son las props por defecto MÁS children
export default class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught", error, info);
    try {
      window.dispatchEvent(new CustomEvent("app:fatalError", { detail: { message: String(error.message || "Error desconocido"), source: "errorBoundary" } }));
    } catch { }
    try { localStorage.setItem(`err_${Date.now()}`, JSON.stringify({ message: String(error), info })); } catch { }
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <Box
            sx={{
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
              backgroundImage: "#FFFF",
              backgroundSize: "cover",
            }}
          >
            {/* Figura geométrica superior */}
            <img
              src={topPattern}
              alt="Top Pattern"
              style={{
                position: "absolute",
                top: "-150px",
                left: 0,
                width: "100%",
                height: "auto",
              }}
            />

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: 1.5,
                textAlign: "center",
                zIndex: 5, 
              }}
            >
              <Image
                style={{ width: 350, height: "auto" }}
                alt="Error Page"
                src={ErrorPage}
              />

              <Typography
                sx={{
                  color: "#336B87",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  fontSize: "1.8rem",
                  fontWeight: "bold",
                  mt: 3,
                }}
                variant="h3"
              >
                Ups... ALGO NO CARGÓ COMO ESPERÁBAMOS.
              </Typography>

              <Typography
                sx={{
                  color: "rgba(0,0,0,0.6)",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  fontSize: "1.2rem",
                  mt: 3,
                }}
                variant="h3"
              >
                La carga falló, pero no te preocupes: estamos trabajando para que todo vuelva a fluir.
              </Typography>
              <Typography
                sx={{
                  color: "rgba(0,0,0,0.6)",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  fontSize: "1.2rem",
                  fontWeight: 550
                }}
                variant="h3"
              >
                Puedes refrescar la página o volver más tarde.
              </Typography>

              <Typography
                sx={{
                  color: "rgba(0,0,0,0.4)",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  fontSize: "1rem",
                  textTransform:"capitalize",
                  mt: 3,
                  mb: 2
                }}
                variant="h3"
              >
                UmmIA sigue contigo.
              </Typography>

             
              <Button
                onClick={() => {
                 clearCacheAndReloadForVerification();

                }}
                style={{ background: "#336B87", color: "#fff", border: "none", padding: "8px 12px", borderRadius: 8 }}
              >
                Vaciar caché y recargar
              </Button>
            </Box>

          {/* Figura geométrica inferior */}
          <img
            src={bottomPattern}
            alt="Bottom Pattern"
            style={{
              position: "fixed",
              bottom: "-150px",
              left: 0,
              width: "100%",
              height: "auto",
            }}
          />
        </Box >
        </>
      );
    }
    return this.props.children as React.ReactElement | null;
  }
}
